
import * as app from 'actions/app';
import * as chat from 'actions/chat';
import * as actions  from 'actions/chat/fileUpload';
import { List, Map } from 'immutable';

const initialState = {
  files: List(),
  error: undefined,
  fileUploadProgress: undefined,
  receivedImages: Map(),
  receivedImageBeingShown: undefined,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.MINIMIZE:
      return { ...state, files: state.fileUploadProgress ? state.files : List() };
    case actions.SELECT_FILES:
      return { ...state, files: List(action.files) };
    case actions.UPLOAD_START:
      return { ...state, error: undefined,
        fileUploadProgress: List(action.files).map(f => 0),
      };
    case actions.UPLOAD_ERROR:
      return { ...state, error: action.error, files: List(), fileUploadProgress: undefined };
    case actions.UPLOAD_PROGRESS:
      return { ...state,
        fileUploadProgress: state.fileUploadProgress.set(action.index, action.percentaje)
      };
    case actions.UPLOAD_FILE_COMPLETED:
      return { ...state,
        fileUploadProgress: state.fileUploadProgress.set(action.index, true)
      };
    case actions.UPLOAD:
      return { ...initialState };
    case actions.RECEIVE_IMAGES:

      return { ...state,
        receivedImages: !action.images || action.images.length === 0
          ? state.receivedImages
          : state.receivedImages.concat(action.images.map(i => [i.id, i]))
      };
    case actions.IMAGE_VIEW:
      return { ...state, receivedImageBeingShown: action.image };
    case actions.IMAGE_VIEW_CANCEL:
      return { ...state, receivedImageBeingShown: undefined };
    case app.RESET:
      return { ...initialState };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./reducers/chat/fileUpload.js